
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, isDevMode } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GlobalUtilService } from '../core/services/global-util.service';

export function initializeTauriApp(globalUtilService: GlobalUtilService) {
  return () => globalUtilService.initializeTauri();
}
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule, routes } from './app-routing.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreModule } from '@otas/core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@otas/shared/shared.module';
import { AppComponent } from './app.component';
import { LoginStodaComponent } from './login-stoda/login-stoda.component';
import { NonAuthenticatedComponent } from './authenticated/non-authenticated/non-authenticated.component';
import { ExpiryGuard } from 'guards/expiry.guard';
import { ToasterService } from './services/toaster.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NotificationInterceptor } from './services/notifictaion.interceptor';
import { AuthInterceptor } from './services/auth.interceptor';
import { RouterModule } from '@angular/router';
import { PanchangPopupHelperService } from './services/panchang-popup-helper.service';
import { UtilService } from './services/util.service';
import { NgCircleProgressModule } from '../utils/ng-circle-progress/ng-circle-progress.module';

import { NgScrollbarModule } from 'ngx-scrollbar';
import { ScrollingModule } from "@angular/cdk/scrolling";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";



import { NgSelectModule } from '@ng-select/ng-select';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getAuth, provideAuth } from "@angular/fire/auth";
import { environment } from '../environments/environment';
import { WINDOW_PROVIDERS } from "./services/window.provider";

import { NgModule } from '@angular/core';
import { LoaderSpinnerInterceptor } from './services/loader.interceptor';
import { HttpCancelService } from './services/httpcancel.service';
import { ManageHttpInterceptor } from './services/managehttp.interceptor';
import { ImageCropperModule } from '@otas/utils/image-cropper/image-cropper.module';
import { TempleAddressComponent } from './temple-address/temple-address.component';
import { TempleOwnerLoginComponent } from './temple-owner-login/temple-owner-login.component';
import { TempleProfileComponent } from './temple-profile/temple-profile.component';

export const APP_IMPORTS = [

    BrowserModule,
    BrowserAnimationsModule, ImageCropperModule,
    AppRoutingModule,
    RouterModule.forRoot(routes, { useHash: false, onSameUrlNavigation: 'reload' }),
    CoreModule,

    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode() && !(window as any).isTauri?.(),
      registrationStrategy: 'registerWhenStable:30000'
    }),

    // NgxElectronModule,
    ReactiveFormsModule,
    SharedModule.forRoot(),
    BrowserAnimationsModule,
    NgCircleProgressModule.forRoot(),
    NgScrollbarModule,
    ScrollingModule,
    NgSelectModule,

    NgbModule,
    FlexLayoutModule,


    TempleOwnerLoginComponent,
    TempleProfileComponent,
    TempleAddressComponent
];
export const APP_DECLARATION = [
    AppComponent,
    AppRoutingModule.COMPONENTS,
    LoginStodaComponent,
    NonAuthenticatedComponent
];

export const APP_PROVIDERS = [
    PanchangPopupHelperService,
    ToasterService, ExpiryGuard,
    AppRoutingModule.RESOLVERS,
    UtilService,
    HttpCancelService,
    {
        provide: HTTP_INTERCEPTORS,
        useClass: NotificationInterceptor,
        multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: LoaderSpinnerInterceptor,
        multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ManageHttpInterceptor,
        multi: true
    },
    {
        provide: APP_INITIALIZER,
        useFactory: initializeTauriApp,
        deps: [GlobalUtilService],
        multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),

    ...WINDOW_PROVIDERS
];





@NgModule({
    declarations: [
        ...APP_DECLARATION


    ],
    imports: [
        ...APP_IMPORTS
    ],

    providers: [
        ...APP_PROVIDERS
    ],
    bootstrap: [
        AppComponent
    ]
})

export class AppModule { }
